const types = {
  SET_CURRENT_CMS: 'SET_CURRENT_CMS'
};
const state = {
  currentCms: null
};

const mutations = {
  [types.SET_CURRENT_CMS]: (state, value) => {
    state.currentCms = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
